import { Button, DatePicker } from '@symphony-ui/uitoolkit-components';
import PopupContext from 'contexts/PopupContext';
import RenderingContext from 'contexts/RenderingContext';
import * as React from 'react';
const DatePickerPopUp = ({ hasOverride, hasValue, initialValue, isDisabled, save }) => {
    const { datePattern } = React.useContext(RenderingContext);
    const { setBlockClose } = React.useContext(PopupContext);
    React.useEffect(() => setBlockClose(true), [setBlockClose]);
    const value = React.useMemo(() => typeof initialValue === 'object' && 'value' in initialValue && initialValue.value instanceof Date ? initialValue.value : undefined, [initialValue]);
    const onClickRemove = React.useCallback(() => {
        (async () => save(undefined))();
    }, [save]);
    const onClickTbc = React.useCallback(() => {
        (async () => save('TBC'))();
    }, [save]);
    const onChange = React.useCallback((event) => {
        const date = event.target.value;
        const dateText = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString().substring(0, 10);
        (async () => save(dateText))();
    }, [save]);
    return React.createElement(React.Fragment, null,
        React.createElement(DatePicker, { autoFocus: true, date: value, disabled: isDisabled, format: datePattern('YMD'), onChange: onChange, showRequired: true, showOverlay: true }),
        React.createElement("div", { style: { display: 'flex', justifyContent: 'center' } },
            hasValue
                ? React.createElement("div", null,
                    React.createElement(Button, { onClick: onClickTbc, variant: "tertiary-accent" }, "TBC")) : undefined,
            hasOverride
                ? React.createElement("div", null,
                    React.createElement(Button, { onClick: onClickRemove, variant: "tertiary-destructive" }, "REMOVE")) : undefined));
};
export default DatePickerPopUp;
